import { gql } from '@apollo/client'

export const StartMultipartUpload = gql`
    mutation StartMultipartUpload($hash: String!) {
        startMultipartUpload(hash: $hash)
    }
`

export default StartMultipartUpload
